<template>
  <div class="agreement_index">
    <!-- <div @click="aaaaa">
      3324324
    </div>
    <van-button round block type="info" native-type="submit" @click="getForm">getForm</van-button> -->
    <van-form @submit="onSubmit" input-align="right" label-width="110px">
      <van-collapse v-model="papersShow" accordion class="form-crad">
        <van-collapse-item title="证照信息" name="1" :is-link="false">

          <van-field v-model="form.extended.enterpriseName" required label="企业名称" placeholder="请填写企业名称" :rules="[{ required: true }]" />

          <van-field v-model="form.extended.registrationNumber" required label="营业执照注册号" placeholder="请填写营业执照注册号" :rules="[{ required: true  }]" />

          <van-field v-model="form.extended.firmType" name="企业类型" required label="企业类型" placeholder="请填写企业类型" :rules="[{ required: true }]" />

          <van-field v-model="form.extended.firmAddress" name="企业住所" required label="企业住所" placeholder="请填写企业住所" :rules="[{ required: true }]" />

          <van-field v-model="form.extended.representative" name="法定代表人" required label="法定代表人" placeholder="请填写法定代表人" :rules="[{ required: true }]" />

          <van-field v-model="form.extended.registerMoney" name="企业注册资金" required label="企业注册资金" placeholder="请填写企业注册资金" :rules="[{ required: true }]" />

          <van-field readonly clickable name="calendar" required :value="form.extended.registerDate" label="成立日期" placeholder="点击选择成立日期" @click="showRegisterDate = true" :rules="[{ required: true }]" right-icon="arrow" />
          <van-calendar v-model="showRegisterDate" color="#4088EE" @confirm="onRegisterDateChange" :min-date="minDate" :max-date="maxDate" />

          <van-field readonly clickable name="calendar" required :value="form.extended.allottedDate" label="营业期限" placeholder="点击选择营业期限" @click="showManageScope = true" :rules="[{ required: true }]" right-icon="arrow" />
          <van-calendar v-model="showManageScope" color="#4088EE" @confirm="onManageScopeChange" :min-date="minDate" :max-date="maxDate" />

          <van-field label="经营范围" required readonly class="notborder" />
          <div class="textarea-box">
            <textarea type="textarea" v-model="form.extended.manageScope" class="textarea-input" />
          </div>

          <van-field v-model="form.extended.registry" name="企业登记机关" required label="企业登记机关" placeholder="请填写企业登记机关" :rules="[{ required: true }]" />

          <van-field name="uploader" required label="营业执照">
            <template #input>
              <div class="img-text">
                <div>最佳比例：宽1080px，高608px；或宽750px，高422px；格式为jpg或png</div>
              </div>
              <van-uploader v-model="form.licenseUrl" class="one-img" :before-read="uploadaaa" :max-count="1" />
            </template>
          </van-field>

        </van-collapse-item>
        <div class="slider-text" @click="papersShow = papersShow ==1 ? '2' : '1'">
          {{papersShow == 1 ? '收起' : '展开'}} <van-icon :name="papersShow == 1 ? 'arrow-up' : 'arrow-down'" />
        </div>

      </van-collapse>

      <van-collapse v-model="infoShow" accordion class="form-crad">
        <van-collapse-item title="基本资料" name="1" :is-link="false">
          <!-- <div class="title">基本资料</div> -->
          <van-field v-model="form.branchName" name="店铺名称" :disabled="$route.query.type == 'edit'" required label="店铺名称" placeholder="请填写店铺名称" :rules="[{ required: true }]" />

          <van-field v-if="$route.query.type != 'edit'" v-model="form.password" name="账户密码*" required label="账户密码" placeholder="请填写账户密码" :rules="[{ required: true }]" />

          <van-field readonly clickable name="picker" required :value="logoIdShow" label="所属品牌" placeholder="选择所属品牌" @click="showLogoId = true" right-icon="arrow" />
          <van-popup v-model="showLogoId" position="bottom">
            <van-picker show-toolbar :columns="shopLogoList" ref="logoId" value-key="brandName" @confirm="logoIdChange" @cancel="showLogoId = false" />
          </van-popup>

          <van-field readonly clickable name="picker" required class="nowrap-input" :value="relatedCategory" label="商品关联分类" placeholder="商品关联分类" @click="showRelatedCategory = true;index1=0" right-icon="arrow" />
          <van-popup v-model="showRelatedCategory" position="bottom">
            <div class="cascader-box">
              <div class="cascader-title">
                <span style="flex: 1;">商品关联分类</span>
                <img class="img-icon" src="../../assets/close.png" @click="relatedCategoryChange" />
              </div>
              <van-row class="cascader-body">
                <van-col span="8" class="col-item">
                  <van-checkbox-group v-model="indexlist1">
                    <van-cell-group>
                      <van-cell v-for="(item,index) in cateLsitOption" :key="item.id" clickable :title="item.categoryName" @click="toggle1(item,index)" :class="index1 == index ? 'atvcheck' : ''">

                        <template #title>
                          <span :class="item.children.filter(v=>v.check).length || item.children.filter(v=>v.checkAll).length ? 'check-color' :''">
                            {{ item.categoryName}}
                          </span>
                        </template>

                        <template #right-icon>
                          <van-checkbox :name="item.id" ref="checkboxes" @click="toggleCheck1(item,index,1)">
                            <template #icon="props">
                              <img class="img-icon" v-if="item.children.filter(v=>v.check).length || item.children.filter(v=>v.checkAll).length" :src="item.children.filter(v=>v.checkAll).length ==  item.children.length ? checkAll : checkIndeter" />
                              <img class="img-icon" v-else :src="checkNot" />
                            </template>
                          </van-checkbox>
                        </template>

                      </van-cell>
                    </van-cell-group>
                  </van-checkbox-group>
                </van-col>

                <van-col span="8" :class="index1 != -1 && index2 == -1 ? 'col-item col-item-notbg' : 'col-item'">
                  <van-checkbox-group v-model="indexlist2" v-if="index1 != -1">
                    <van-cell-group>
                      <van-cell v-for="(item,index) in cateLsitOption[index1].children" :key="item.id" clickable :title="item.categoryName" @click="toggle2(item,index)" :class="index2 == index ? 'atvcheck1' : ''">
                        <template #title>
                          <span :class="item.children.filter(v=>v.check).length || item.children.filter(v=>v.checkAll).length ? 'check-color' :''">
                            {{ item.categoryName}}
                          </span>
                        </template>

                        <template #right-icon>
                          <van-checkbox :name="item.id" ref="checkboxes" @click="toggleCheck1(item,index,2)">
                            <template #icon="props">
                              <img class="img-icon" v-if="item.children.filter(v=>v.check).length" :src="item.children.filter(v=>v.check).length ==  item.children.length ? checkAll : checkIndeter" />
                              <img class="img-icon" v-else :src="checkNot" />
                            </template>
                          </van-checkbox>
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-checkbox-group>
                </van-col>
                <van-col span="8" :class="index2 == -1 ? 'col-item' : 'col-item col-item-notbg'">
                  <van-checkbox-group v-model="indexlist3" v-if="index2 != -1">
                    <van-cell-group>
                      <van-cell v-for="(item,index) in cateLsitOption[index1].children[index2].children" :key="item.id" clickable :title="item.categoryName" @click="toggle3(item,index,cateLsitOption[index1].children[index2])">
                        <template #title>
                          <span :class="item.check ? 'check-color' :''">
                            {{ item.categoryName}}
                          </span>
                        </template>
                        <template #right-icon>
                          <van-checkbox :name="item.id" ref="checkboxes">
                            <template #icon="props">
                              <img class="img-icon" :src="item.check ? checkAll : checkNot " />
                            </template>
                          </van-checkbox>
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-checkbox-group>
                </van-col>
              </van-row>
            </div>
            <van-button round block type="info" native-type="submit" class="cascader-btn" @click="relatedCategoryChange">确 定</van-button>

            <!-- <van-picker show-toolbar :columns="cateLsitOption" ref="relatedCategory" value-key="categoryName" @confirm="relatedCategoryChange" @cancel="showRelatedCategory = false" /> -->
          </van-popup>

          <van-field v-model="form.extended.linkman" name="联系人" required label="联系人" placeholder="请填写联系人" :rules="[{ required: true }]" />

          <van-field type="number" v-model="form.extended.phone" required label="联系电话" placeholder="请填写联系电话" :rules="[{ required: true }]">
            <!-- <template #input>
              <van-field v-model="form.extended.phone" type="tel" />
            </template> -->
          </van-field>

          <van-field name="uploader" required label="店铺图">
            <template #input>
              <div class="img-text">
                <div>最佳比例：宽1080px，高608px；或宽750px，高422px；格式为jpg或png</div>
              </div>
              <van-uploader v-model="form.branchIconImageUrl" class="one-img" :before-read="branchIconImageUrlChange" :max-count="1" />
            </template>
          </van-field>

          <van-field label="店铺位置" required readonly class="notborder" />
          <div class="textarea-box">
            <textarea type="textarea" v-model="form.extended.address" class="textarea-input" />
          </div>

          <van-field label="详情" required readonly class="notborder" />
          <div class="textarea-box">
            <textarea type="textarea" v-model="form.info" class="textarea-input" />
          </div>

          <van-field name="uploader" required label="店铺轮播图" class="notborder" />
          <div class="all-img-box">
            <div class="text">
              <div>最佳比例：宽1080px，高608px；或宽750px，高422px；格式为jpg或png</div>
            </div>
            <van-uploader v-model="form.branchImages" class="all-img" :before-read="branchImagesChange" :max-count="5" />
          </div>

          <van-field readonly clickable name="picker" required :value="associatedDetails" label="所属管辖权限" placeholder="选择所属管辖权限" @click="showAssociatedDetails = true" right-icon="arrow" />
          <van-popup v-model="showAssociatedDetails" title="选择所属管辖权限" position="bottom" @close="associatedDetailsChange">

            <div class="cascader-box">
              <div class="cascader-title">
                <span style="flex: 1;">选择所属管辖权限</span>
                <img class="img-icon" src="../../assets/close.png" @click="showAssociatedDetails = false" />
                <!-- <span @click="showAssociatedDetails = false" class="close-btn">确定</span> -->
              </div>
            </div>

            <van-checkbox-group v-model="form.associatedDetails" class="checkbox-box">
              <van-checkbox class="checkbox-row" v-for="item in sysDataList1" :key="item.id" :name="item.id">
                {{item.dataGroupName}}
              </van-checkbox>
            </van-checkbox-group>

            <van-button round block type="info" native-type="submit" class="cascader-btn" @click="showAssociatedDetails = false">确 定</van-button>
          </van-popup>

          <van-field readonly clickable name="picker" required :value="runMode" label="店铺经营方式" placeholder="选择店铺经营方式" @click="showRunMode = true" right-icon="arrow" />
          <van-popup v-model="showRunMode" position="bottom">
            <van-picker show-toolbar :columns="runModeOption" value-key="label" @confirm="runModeChange" @cancel="showRunMode = false" />
          </van-popup>
          <van-field readonly clickable required name="picker" :value="shopFormatName" label="所属业态" placeholder="选择店铺所属业态" @click="showshopFormat = true" right-icon="arrow" />
          <van-popup v-model="showshopFormat" position="bottom">
            <van-picker show-toolbar :columns="yetaiList" value-key="label" @confirm="shopFormatChange" @cancel="showshopFormat = false" />
          </van-popup>

          <van-field v-model="form.agentPhone" type="number" name="代办人联系电话" label="代办人联系电话" />

          <van-field name="switch" label="接收短信通知">
            <template #input>
              <van-switch v-model="form.notify" size="20" :active-value="true" :inactive-value="false" />
            </template>
          </van-field>
        </van-collapse-item>
        <div class="slider-text" @click="infoShow = infoShow ==1 ? '2' : '1'">
          {{infoShow == 1 ? '收起' : '展开'}} <van-icon :name="infoShow == 1 ? 'arrow-up' : 'arrow-down'" />
        </div>

      </van-collapse>

      <van-collapse v-model="sliderText1" accordion class="form-crad footer-card">
        <van-collapse-item name="1" :is-link="false">
          <template #title>
            <div>订单设置</div>
          </template>
          <van-field readonly clickable  required name="cascader" :value="afterTemplateText" label="默认售后模板" placeholder="选择默认售后模板" @click="afterTemplatePopupShow = true" right-icon="arrow" />
          <van-popup v-model="afterTemplatePopupShow" position="bottom">
            <van-cascader
            v-model="afterTemplate"
            title="选择默认售后模板"
            :options="afterTemplateList"
            @change="handleAfterTepChange"
            @finish="handleAfterTeponFinish"
            @close="afterTemplatePopupShow = false"
          />
          </van-popup>

          <van-field readonly clickable  required name="calendar" :value="afterTemplateTime" label="售后模板时间" placeholder="请选择售后模板时间" @click="afterTemplateTimeShow = true" right-icon="arrow" />
          <van-calendar v-model="afterTemplateTimeShow" type="range" @confirm="afterTemplateTimeonConfirm" />

          <van-field readonly clickable required name="picker" :value="itemFrightIdText" label="默认运费模板" placeholder="选择默认运费模板" @click="itemFrightIdTextShow = true" right-icon="arrow" />
          <van-popup v-model="itemFrightIdTextShow" position="bottom">
            <van-picker show-toolbar :columns="freightTemplateList" value-key="frightName" @confirm="itemFrightIdTextConfirm" @cancel="itemFrightIdTextShow = false" />
          </van-popup>

        </van-collapse-item>
        <div class="slider-text" @click="sliderText1 = sliderText1 ==1 ? '2' : '1'">
          {{sliderText1 == 1 ? '收起' : '展开'}} <van-icon :name="sliderText1 == 1 ? 'arrow-up' : 'arrow-down'" />
        </div>
      </van-collapse>
      <van-collapse v-if="onlineStore" v-model="sliderText2" accordion class="form-crad footer-card">
        <van-collapse-item name="1" :is-link="false">
          <template #title>
            <div>线上店铺积分设置</div>
          </template>
          <van-field readonly clickable  required :value="onlineStore.integralRuleName" label="积分规则" placeholder="请选择" @click="onlineStore.showRulePicker = true" right-icon="arrow" />
          <van-popup v-model="onlineStore.showRulePicker" position="bottom">
            <van-picker show-toolbar :columns="onlineStore.integralRuleList" value-key="ruleName" @confirm="onIntegralRulePickerConfirm" @cancel="onlineStore.showRulePicker = false" />
          </van-popup>
        </van-collapse-item>
        <div class="slider-text" @click="sliderText2 = sliderText2 ==1 ? '2' : '1'">
          {{sliderText2 == 1 ? '收起' : '展开'}} <van-icon :name="sliderText2 == 1 ? 'arrow-up' : 'arrow-down'" />
        </div>
      </van-collapse>

      <van-collapse v-model="sliderText" accordion class="form-crad footer-card">
        <van-collapse-item name="1" :is-link="false">
          <template #title>
            <div>其它信息<span class="title-span"><van-icon name="warning" />其他信息为非必填资料可后续填写</span></div>
          </template>
          <van-field readonly clickable name="picker" :value="groupId" label="所属管辖部门" placeholder="选择所属管辖部门" @click="showGroupId = true" right-icon="arrow" />
          <van-popup v-model="showGroupId" position="bottom">
            <van-picker show-toolbar :columns="groupOptions" value-key="groupName" @confirm="groupIdChange" @cancel="showGroupId = false" />
          </van-popup>

          <van-field readonly clickable name="picker" :value="chatMode" label="店铺咨询方式" placeholder="选择店铺咨询方式" @click="showChatMode = true" right-icon="arrow" />
          <van-popup v-model="showChatMode" position="bottom">
            <van-picker show-toolbar :columns="chatOperations" value-key="label" @confirm="chatModeChange" @cancel="showChatMode = false" />
          </van-popup>

          <van-field readonly clickable name="picker" required :value="giftCardMode.label" label="线上储值卡" placeholder="请选择" @click="giftCardMode.show = true" right-icon="arrow" />
          <van-popup v-model="giftCardMode.show" position="bottom">
            <van-picker show-toolbar :columns="giftCardMode.columns" value-key="label" @confirm="onGiftCardModeConfirmChange" @cancel="giftCardMode.show = false" />
          </van-popup>

          <van-field name="switch" label="是否商场代收">
            <template #input>
              <van-switch v-model="form.isShopAgentCashier" :active-value="2" :inactive-value="1" size="20" />
            </template>
          </van-field>
        </van-collapse-item>
        <div class="slider-text" @click="sliderText = sliderText ==1 ? '2' : '1'">
          {{sliderText == 1 ? '收起' : '展开'}} <van-icon :name="sliderText == 1 ? 'arrow-up' : 'arrow-down'" />
        </div>
      </van-collapse>

      <div class="footer-btn">
        <van-button round block type="info" native-type="submit" :disabled="disabledBtn" v-if="$route.query.type == 'edit'" @click="submitForm('edit')">编辑</van-button>
        <van-button round block type="info" native-type="submit" :disabled="disabledBtn" v-else @click="submitForm">提交</van-button>

      </div>
    </van-form>

    <!-- <van-popup v-model="popupShow">内容</van-popup> -->

    <van-dialog v-model="popupShow" title="提示" show-cancel-button class="dialog" :showCancelButton="false" confirmButtonText="我知道了" confirmButtonColor="#596B93" @close="close">
      <div class="dialog-row" @click="copyCode">
        <div class="label">申请编号：</div>
        <div class="value">{{branchApplyForm.applyCode}}</div>
        <span class="copy-icon">复制</span>
      </div>
      <div class="dialog-row">
        <div class="label">账户名：</div>
        <div class="value">{{branchApplyForm.username}}</div>
      </div>
      <div class="text-success">
        请及时记住申请编号、账户名信息，方便后续查看申请进度哦！
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Util from "@/utils/common";
import http from "@/utils/axios";
import axios from 'axios';
import { text } from "body-parser";
export default {
  data() {
    return {
      afterTemplateText:'',
      afterTemplatePopupShow:false,
      afterTemplateList:[],
      afterTemplate:'',

      afterTemplateTimeShow:false,
      afterTemplateTime:'',

      itemFrightIdTextShow:false,
      itemFrightIdText:'',
      freightTemplateList:[],

      // 定义日历的范围
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(2100, 0, 31),
      disabledBtn: false,
      papersShow: "1",
      infoShow: "1",
      sliderText: "1",
      sliderText1: "1",
      sliderText2: "1",
      shopId: "",
      popupShow: false,
      branchApplyForm: {
        // applyCode: "167792839052867294",
        // branchName: "shulx店铺1",
        // id: 423,
        // username: "100224@100224",
      },
      // logoIdShow      所属品牌
      // associatedDetails  所属管辖权限
      // runMode        店铺经营方式
      // groupId        所属管辖部门
      // chatMode       店铺咨询方式
      logoIdShow: "",
      associatedDetails: "",
      runMode: "",
      groupId: "",
      chatMode: "",
      showRegisterDate: false,
      showManageScope: false,
      showPicker: false,
      showLogoId: false,
      showRelatedCategory: false,
      showGroupId: false,
      showChatMode: false,
      showAssociatedDetails: false,
      showRunMode: false,
      relatedCategory: "",
      uploader: [{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }],
      form: {
        afterTemplate:'',
        afterTemplateDescriptionId:'',
        relatedCategory: [],
        licenseUrl: [],
        branchIconImageUrl: [],
        branchImages: [],
        notify: true,
        isShopAgentCashier: 1,
        branchName: "",
        categoryId: "",
        branchIconKey: "",
        branchImageKeys: "",
        info: "",
        licenseKey: "",
        logoId: "",
        itemFrightId: "",
        runMode: "",
        associatedDetails: [],
        integralRule: '',
        storeGroupId: '',
        extended: {
          //扩展字段
          address: "",
          todayActivity: "",
          linkman: "",
          phone: "",
          enterpriseName: "",
          registrationNumber: "",
          firmType: "",
          firmAddress: "",
          representative: "",
          registerMoney: "",
          registerDate: "",
          allottedDate: "",
          manageScope: "",
          registry: "",
          iprovinceId: "",
          iprovince: "",
          icityId: "",
          icity: "",
          iareaId: "",
          iarea: "",
          iaddress: "",
          ilongitude: "",
          ilatitude: "",
        },
        shopFormatId:'',
        savingsCardOpen: null
      },
      shopLogoList: [],
      cateLsitOption: [],
      runModeOption: [
        { label: "自营店铺", value: "1" },
        { label: "非自营店铺", value: "2" },
        { label: "商场直营", value: "3" },
        { label: "云店", value: "4" },
        { label: "供应链", value: "5" },
      ],
      chatOperations: [
        { label: "单聊模式", value: 1 },
        { label: "群聊模式", value: 2 }
      ],
      groupOptions: [],
      sysDataList1: [],
      voucherImgUrls: [],
      checkNot: require("@/assets/image/check-not.png"),
      checkAll: require("@/assets/image/check-all.png"),
      checkIndeter: require("@/assets/image/check-indeter.png"),
      // activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      // inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      indexlist1: [],
      indexlist2: [],
      indexlist3: [],
      index1: -1,
      index2: -1,
      onlineStore: null,
      shopFormatName:'',
      showshopFormat:false,
      yetaiList:[],
      giftCardMode: {
        label: '不允许使用',
        show: false,
        columns: [
          { label: "不允许使用", value: 0 },
          { label: "允许使用", value: 1 },
          { label: "以关联线下店铺是否允许使用为准，若未关联则默认不允许使用；", value: 2 ,disabled:true},
        ]
      }
    };
  },
  created() {
    this.$loading.hide();
    this.shopLogolist();
    this.handleCategoryLoad();
    this.getBranchGroupList();
    this.getsysDataList1();
    this.shopId = this.$route.query.shopId;
    this.getAfterTemplate()
    this.getFreightTemplate()
    this.getOnlineStorePointConfig();
    this.getformatQuerySelectList();
    if (this.$route.query.type == "edit") {
      this.getForm();
    }
    else {
      // this.runModeChange(this.runModeOption[0]);
    }
  },
  methods: {
    getFreightTemplate() {
      const parm = {
        pageIndex:1,
        pageSize:999,
        shopId:this.$route.query.shopId || ''
      };
      http({url:"/item/biz/fright/page",method:"post",parmes:parm}).then((res) => {
        if (res.code == 200) {
          console.log(res,1233);
          this.freightTemplateList = res.data;
        }
      });
    },
    itemFrightIdTextConfirm(value){
      this.itemFrightIdTextShow = false
      this.itemFrightIdText = value.frightName
      this.form.itemFrightId = value.id
      console.log(value);
    },
    afterTemplateTimeonConfirm(date) {
      this.afterTemplateTimeShow = false;
      var [start,end] = date
      let startTime = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`;
      let endTime = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`;
      this.form.afterTemplateStartTime = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()} 00:00:00`;
      this.form.afterTemplateEndTime = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()} 23:59:59`;
      this.afterTemplateTime = `${startTime} 至 ${endTime}`
    },
    getAfterTemplate() {
      http({url:"/order/admin/branch/afterTemplate",method:"get"}).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          let afterTemplate = this.form.afterTemplate;
          if(['RETURNABLE','UNRETURNABLE','VIRTUAL_UNRETURNABLE'].includes(afterTemplate)){
            if(afterTemplate == 'RETURNABLE'){
              data.push({
                value:afterTemplate,
                desc:'可退可换'
              })
            }else if(afterTemplate == 'UNRETURNABLE'){
              data.push({
                value:afterTemplate,
                desc:'不可退不可换'
              })
            }else{
              data.push({
                value:afterTemplate,
                desc:'不可退不可换虚拟商品'
              })
            }
          }
          this.afterTemplateList = data.map(item => {return {value:item.value,text:item.desc,children:[]}});
        }
      });
    },
    handleAfterTepChange({value}) {
      if (value) {
        let form ={
          pageNum: 1,
          pageSize: 100000,
          afterTemplate: value,
        }
        http({url:"/order/admin/after-template-description/pageList",method:"post",parmes:form}).then((res)=> {
          if (res.code == 200) {
            let _index = this.afterTemplateList.findIndex(item => item.value == value)
            console.log(res,_index);
            if (_index >= 0) {
              this.afterTemplateList[_index].children = [];
              res.data.list.map(item => {
                 
                 console.log(item);
                 this.afterTemplateList[_index].children.push({value:item.id,text:item.name}) 
                });
            }

          }

        })
      }
    },
    handleAfterTeponFinish({ selectedOptions }) {
      console.log(selectedOptions);
      this.afterTemplatePopupShow = false;
      this.afterTemplateText = selectedOptions.map((option) => option.text).join('/');
      if (selectedOptions.length>=2) {
        this.form.afterTemplate = selectedOptions[0].value
        this.form.afterTemplateDescriptionId = selectedOptions[1].value
      }
    },
    toggle1(e, index) {
      this.index1 = index;
      this.index2 = -1;
    },
    toggleCheck1(e, index, level) {

      if (level == 1) {
        if (e.children.filter(v => v.checkAll).length == e.children.length) {
          console.log(11111111);
          e.children.forEach(item => {
            item.check = false;
            item.checkAll = false;
            if (item.children && item.children.length) {
              item.children.forEach(item2 => {
                item2.check = false;
              });
            }
          });
        }
        else {
          console.log(22222222);
          e.check = true;
          e.checkAll = true;
          e.children.forEach(item => {
            item.check = true;
            item.checkAll = true;
            if (item.children && item.children.length) {
              item.children.forEach(item2 => {
                item2.check = true;
              });
            }
          });
        }
      }
      if (level == 2) {
        if (e.children.filter(v => v.check).length == e.children.length) {
          e.check = false;
          e.checkAll = false;
          e.children.forEach(item => {
            item.check = false;
          });
        }
        else {
          e.check = true;
          e.checkAll = true;
          e.children.forEach(item => {
            item.check = true;
          });
        }
      }
      this.$set(this, "cateLsitOption", this.cateLsitOption);
      this.$nextTick();
      console.log(e, index);
    },
    toggle2(e, index) {
      console.log(222);
      console.log(e, index);
      this.index2 = index;
    },
    toggle3(e, index, parent) {
      console.log(3333333333333);
      e.check = !e.check;
      // console.log(parent);
      // console.log(e, index);
      // this.index2 = index
      // console.log(parent.children.filter(v=>v.check));
      // console.log(parent.children.length);
      // console.log(parent.children.filter(v=>v.check).length == parent.children.length);
      if (parent.children.filter(v => v.check).length) {
        if (e.check) {
          parent.check = true;
          this.cateLsitOption[this.index1].check = true;
        }
        parent.checkAll = parent.children.filter(v => v.check).length == parent.children.length;
      }
      else {
        parent.check = false;
        parent.checkAll = false;
      }
      // console.log();
      if(this.cateLsitOption[this.index1].children.find(v=>v.check || v.checkAll) != undefined){
        this.cateLsitOption[this.index1].check = true
      }

      // console.log("393939393");
      // console.log(parent);
      this.$set(this, "cateLsitOption", this.cateLsitOption);
      this.$nextTick();
    },
    close() {
      this.$router.go(-1);
    },
    copyCode() {
      var aux = document.createElement("input");
      aux.setAttribute("value", this.branchApplyForm.applyCode + '       ' + this.branchApplyForm.username);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$toast("复制成功");
    },
    validatorPhone(val) {
      console.log(val);
      return /^1\d{10}$/.test(val);
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    submitForm(type) {
      this.disabledBtn = true;
      setTimeout(() => {
        this.disabledBtn = false;
      }, 1000);
      let form = { ...this.form };
      console.log(form);
      form.shopId = this.shopId;
      // this.form.shopId = 1
      // console.log(this.validatorPhone(this.form.phone));
      let extendedData = {
        enterpriseName: "请填写企业名称",
        registrationNumber: "请填写营业执照注册号",
        firmType: "请填写企业类型",
        firmAddress: "请填写企业住所",
        representative: "请填写法定代表人",
        registerMoney: "请填写企业注册资金",
        registerDate: "请选择成立日期",
        allottedDate: "请选择营业期限",
        manageScope: "请填写经营范围",
        registry: "请填写企业登记机关",
        linkman: "请填写联系人",
        phone: "请填写联系电话",
        address: "店铺位置",
      };
      let keyData = {
        branchName: "请填写店铺名称",
        logoId: "选择所属品牌",
        // relatedCategory:"选择商品关联分类",//
        info: "请填写详情",
        // agentPhone: "代办人联系电话",
        // associatedDetails:"选择所属管辖权限", //
        runMode: "选择店铺经营方式", //
        integralRule: '请选择积分规则',
        // storeGroupId: '请选择店铺分组',
        shopFormatId: '请选择所属业态'
      };
      let extendedValidator = Object.entries(extendedData).find(([v, k]) => !form.extended[v]);
      console.log(extendedValidator);
      if (extendedValidator) {
        return this.$toast(extendedValidator[1]);
      }
      let formValidator = Object.entries(keyData).find(([v, k]) => !form[v] || (!String(form[v]).length));
      console.log(formValidator);
      if (formValidator) {
        return this.$toast(formValidator[1]);
      }
      console.log(22222);

      if(form.notify){
        if(!form.agentPhone){
          return this.$toast('请填写代办人联系电话');
        }
      }
      if (!form.afterTemplate || !form.afterTemplateDescriptionId) {
            this.$toast('请选择默认售后模板');
            return
          }
        if (!form.itemFrightId) {
          this.$toast('请选择默认运费模板');
          return
        }
        if (!form.afterTemplateStartTime || !form.afterTemplateEndTime) {
          this.$toast('请选择售后模板时间！');
          return
        }
      // return
      // if (!this.validatorPhone(this.form.extended.phone)) {
      //   return this.$toast("联系电话格式有误");
      // }
      // if (this.form.agentPhone && !this.validatorPhone(this.form.agentPhone)) {
      //   return this.$toast("代办人联系电话格式有误");
      // }
      // 营业执照 licenseUrl
      if (form.licenseUrl.length) {
        form.licenseKey = form.licenseUrl[0].fileKey;
        delete form.licenseUrl;
      }
      else {
        return this.$toast("请上传营业执照");
      }
      // 店铺图  branchIconImageUrl
      if (form.branchIconImageUrl.length) {
        form.branchIconKey = form.branchIconImageUrl[0].fileKey;
        delete form.branchIconImageUrl;
      }
      else {
        return this.$toast("请上传店铺图");
      }
      // 店铺轮播图  branchImages
      if (form.branchImages.length) {
        form.branchImageKeys = JSON.stringify(form.branchImages.map(v => v.fileKey)).replace(/["\[\]]/g, "");
        delete form.branchImages;
      }
      else {
        return this.$toast("请上传店铺轮播图");
      }
      // if (form.relatedCategory.length) {
      //   form.relatedCategory = [form.relatedCategory[2]]
      // }else{
      //   return this.$toast('请选择商品关联分类');
      // }
      form.relatedCategory = this.getCategoryCheck();
      if (!form.relatedCategory.length) {
        return this.$toast("请选择商品关联分类");
      }
      if (form.associatedDetails.length) {
        form.associatedDetails = form.associatedDetails.map(v => ({ dataGroupId: v }));
      }
      else {
        return this.$toast("请选择所属管辖权限");
      }
      console.log(form);
      // console.log(this.getCategoryCheck());
      // return
      if (type == "edit") {
        http({ url: `/order/branch/branch/updateBranch`, method: "post", parmes: form }).then(res => {
          if (res.code == 200) {
            this.branchApplyForm = res.data;
            this.popupShow = true;
            // console.log(this.cateLsitOption);
          }
        });
      }
      else {
        if (!form.password) {
          return this.$toast("请输入密码");
        }
        http({ url: `/order/branch/branch/addBranch`, method: "post", parmes: form }).then(res => {
          if (res.code == 200) {
            this.branchApplyForm = res.data;
            this.popupShow = true;
            // console.log(this.cateLsitOption);
          }
        });
      }
    },
    getCategoryCheck() {
      console.log(34455);
      // console.log(JSON.parse(this.form.relatedCategoryString));
      // console.log(list);
      let list = [];
      // 1
      this.cateLsitOption.forEach(item => {
        if (item.children && item.children.length) {
          // 2
          item.children.forEach(item1 => {
            if (item1.children && item1.children.length) {
              // 3
              item1.children.forEach(item2 => {
                // item2.check = list.includes(item2.id)
                item2.check && list.push(item2.id);
              });
              // 第三级 有选中
              // if(item1.children.filter(v=>v.check).length){
              //   item1.check = true
              //   item1.checkAll = item1.children.filter(v=>v.check) == item1.children.length
              // }else{
              //   // 第三级 没有选中
              //   item1.check = false
              //   item1.checkAll = false
              // }
            }
          });
          // if(item.children.filter(v=>v.check).length){
          //   item.check = true
          //   item.checkAll = item.children.filter(v=>v.check) == item.children.length
          // }else{
          //   item.check = false
          //   item.checkAll = false
          // }
        }
      });
      // console.log(this.cateLsitOption);
      // console.log(191919999);
      // console.log(this.cateLsitOption);
      return list;
    },
    logoIdChange(e) {
      console.log(e);
      // logoIdShow      所属品牌
      // associatedDetails  所属管辖权限
      // runMode        店铺经营方式
      // groupId        所属管辖部门
      // chatMode       店铺咨询方式
      this.logoIdShow = e.brandName;
      this.form.logoId = e.id;
      this.showLogoId = false;
    },
    relatedCategoryChange(e, a) {
      let data = [];
      this.cateLsitOption.forEach(item => {
        if (item.check || item.checkAll) {
          if (item.children && item.children.length) {
            item.children.forEach(item2 => {
              if (item.check || item.checkAll) {
                if (item2.children && item2.children.length) {
                  item2.children.forEach(item3 => {
                    if (item3.check) {
                      data = [item, item2, item3];
                      return;
                    }
                  });
                }
              }
            });
          }
        }
      });
      this.relatedCategory = data.map(v => v.categoryName).toString();

      this.showRelatedCategory = false;
    },
    groupIdChange(e) {
      console.log(e);
      this.showGroupId = false;
      this.groupId = e.groupName;
      this.form.groupId = e.id;
    },
    chatModeChange(e) {
      console.log(e);
      this.chatMode = e.label;
      this.form.chatMode = e.value;
      this.showChatMode = false;
    },
    associatedDetailsChange(e) {
      this.associatedDetails = this.sysDataList1.filter(v => this.form.associatedDetails.includes(v.id)).map(v => v.dataGroupName).join();
      this.showAssociatedDetails = false;
    },
    runModeChange(e) {
      this.runMode = e.label;
      this.form.runMode = e.value;
      this.showRunMode = false;
    },
    onGiftCardModeConfirmChange(e) {
      this.giftCardMode.label = e.label;
      this.giftCardMode.show = false;
      this.form.savingsCardOpen = e.value;
    },
    uploadaaa(e) {
      console.log(123123123);
      //   console.log(e);
      //   console.log(this.uploader);
      //   console.log(e.file);
      let params = {
        "file": e,
        "fileChannel": 1,
        "fileKey": Math.random() * 1000,
        "fileType": "picture"
      };
      http({
        url: "/order/base/oss/upload",
        method: "upload",
        params: params
      }).then(res => {
        if (res.code == 200) {
          this.form.licenseUrl = [{
            fileKey: res.data.fileKey,
            url: res.data.fileUrl
          }];
          console.log(this.form.licenseUrl);
        }
      });
    },
    branchIconImageUrlChange(e) {
      let params = {
        "file": e,
        "fileChannel": 1,
        "fileKey": Math.random() * 1000,
        "fileType": "picture"
      };
      http({
        url: "/order/base/oss/upload",
        method: "upload",
        params: params
      }).then(res => {
        if (res.code == 200) {
          this.form.branchIconImageUrl = [{
            fileKey: res.data.fileKey,
            url: res.data.fileUrl
          }];
          console.log(this.form.branchIconImageUrl);
        }
      });
    },
    branchImagesChange(e) {
      let params = {
        "file": e,
        "fileChannel": 1,
        "fileKey": Math.random() * 1000,
        "fileType": "picture"
      };
      http({
        url: "/order/base/oss/upload",
        method: "upload",
        params: params
      }).then(res => {
        if (res.code == 200) {
          this.form.branchImages.push({
            fileKey: res.data.fileKey,
            url: res.data.fileUrl
          });
          console.log(this.form.branchImages);
        }
      });
    },
    // voucherImgKeysFun() {
    //     console.log(21212);
    //   Util.upLoadImg();
    // },
    // close(index) {
    //   this.voucherImgKeys.splice(index, 1);
    //   this.voucherImgUrls.splice(index, 1);
    // },
    onSubmit() {
    },
    onRegisterDateChange(date) {
      this.form.extended.registerDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showRegisterDate = false;
    },
    onManageScopeChange(date) {
      this.form.extended.allottedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showManageScope = false;
    },
    dataFilter(val) {
      console.log(val);
      this.value = val;
      if (val) {
        this.shopLogolist(val);
      }
      else {
        this.shopLogolist();
      }
    },
    // onConfirmClick(lnglat) {
    //   this.ruleForm.longitude = lnglat[0];
    //   this.ruleForm.latitude = lnglat[1];
    // },
    shopLogolist(brandName) {
      brandName = brandName ? brandName : "";
      http({ url: `/shop/logo/list?brandName=${brandName}`, method: "get" }).then(rps => {
        if (rps.code == 200) {
          this.shopLogoList = rps.data;
        }
      });
    },
    handleCategoryLoad() {
      http({ url: `/order/biz/category/new-all-tree-list`, method: "post", parmes: { status: 0 } }).then(rps => {
        if (rps.code == 200) {
          rps.data.forEach(item => {
            item.check = false;
            item.checkAll = false;
            item.children.forEach(item1 => {
              item1.check = false;
              item1.checkAll = false;
              item1.children.forEach(item2 => {
                item2.check = false;
              });
            });
          });
          this.cateLsitOption = rps.data;
          // console.log(this.cateLsitOption);
          // console.log(999999999999);
          // console.log(this.$route.query.type);
          // console.log(this.form.relatedCategory);
          // console.log(this.relatedCategory);
          // if(this.$route.query.type == 'edit' && this.form.relatedCategory.length && !this.relatedCategory ){
          //   console.log(6666666);
          //   this.setCategoryName()
          // }
        }
      });
      // httpPost("BRANDNEWALLTREELIST", {
      //   status: 0,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     this.cateLsitOption = res.data;
      //   }
      // });
    },
    getBranchGroupList() {
      http({ url: `/shop/admin/branch/groupList`, method: "get" }).then(rps => {
        if (rps.code == 200) {
          this.groupOptions = rps.data;
          console.log(223);
          console.log(this.groupOptions);
        }
      });
      //   httpGet('BRANCHGROUPLIST').then(res => {
      //     if (res.code == 200) {
      //       this.groupOptions = res.data
      //     }
      //   })
    },
    getsysDataList1() {
      http({ url: `/sys/sys/data/dataGroup/list`, method: "post" }).then(rps => {
        if (rps.code == 200) {
          this.sysDataList1 = rps.data;
          console.log(3344);
          console.log(this.sysDataList1);
        }
      });
      //   httpPost("sysDataList1").then((res) => {
      //     if (res.code == 200) {
      //       this.sysDataList1 = res.data;
      //     }
      //   });
    },
    getForm() {
      http({ url: `/shop/admin/branch/${this.$route.query.id}`, method: "get" }).then(res => {
        if (res.code == 200) {
          console.log(res);
          let form = res.data;
          form.extended = JSON.parse(form.extended);
          form.licenseUrl = [{
            fileKey: form.license.imageKey,
            url: form.license.imageUrl
          }];
          form.branchIconImageUrl = [{
            fileKey: form.branchIcon.imageKey,
            url: form.branchIcon.imageUrl
          }];
          form.branchImages = form.branchImages.map(item => ({ fileKey: item.imageKey, url: item.imageUrl }));
          form.relatedCategory = JSON.parse(form.relatedCategoryString);
          this.form = res.data;
          this.shopId = res.data.shopId;
          setTimeout(() => {
            this.setAllPickerName(this.form);
          }, 1000);
        }
      });
    },
    aaaaa() {
      let form = { "notify": true, "isShopAgentCashier": 1, "branchName": "shulx店铺12232331", "categoryId": "", "branchIconKey": "", "branchImageKeys": "", "info": "详情\n", "licenseKey": "", "logoId": 11, "itemFrightId": "", "extended": { "address": "店铺位置\n", "todayActivity": "", "linkman": "联系人", "phone": "联系电话", "enterpriseName": "企业名称", "registrationNumber": "营业执照注册号 请输入营业执照注册号", "firmType": "企业类型", "firmAddress": "企业住所\n", "representative": "法定代表人", "registerMoney": "企业注册资金", "registerDate": "2023-02-01", "allottedDate": "2024-02-09", "manageScope": "经营范围", "registry": "企业登记机关", "iprovinceId": "", "iprovince": "", "icityId": "", "icity": "", "iareaId": "", "iarea": "", "iaddress": "", "ilongitude": "", "ilatitude": "" }, "password": "a12345678", "agentPhone": "13333333333", "groupId": 1, "runMode": "1", "chatMode": 1, "licenseUrl": { "fileKey": "publicoss:uploadfile/2023/2/28/167757176233823067567695161404.png", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757176233823067567695161404.png" }, "branchImages": [{ "fileKey": "publicoss:uploadfile/2023/2/28/167757395446823069759825153923.jpeg", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395446823069759825153923.jpeg" }, { "fileKey": "publicoss:uploadfile/2023/2/28/167757395467423069760031166038.jpeg", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395467423069760031166038.jpeg" }, { "fileKey": "publicoss:uploadfile/2023/2/28/167757395448123069759837828586.jpeg", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395448123069759837828586.jpeg" }, { "fileKey": "publicoss:uploadfile/2023/2/28/167757395440323069759760442017.png", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395440323069759760442017.png" }, { "fileKey": "publicoss:uploadfile/2023/2/28/167757395445523069759812294794.png", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395445523069759812294794.png" }], "branchIconImageUrl": { "fileKey": "publicoss:uploadfile/2023/2/28/167757395855423069763911502421.gif", "fileUrl": "https://img-test.chinabeego.com/uploadfile/2023/2/28/167757395855423069763911502421.gif" }, "relatedCategory": [[79, 10000, 50001], [79, 10000, 50002], [79, 10000, 50003]], "associatedDetails": [2259, 2263, 2276] };

      this.form = form;
      //   this.setAllPickerName(this.form)
      console.log(this.form);
    },
    setAllPickerName(form) {
      //  所属品牌
      let logoId = this.shopLogoList.find(v => v.id == form.logoId);
      this.logoIdChange(logoId);
      //  店铺经营方式
      let runMode = this.runModeOption.find(v => v.value == form.runMode);
      this.runModeChange(runMode);
      //  所属管辖部门
      if (form.groupId) {
        let groupId = this.groupOptions.find(v => v.id == form.groupId);
        this.groupIdChange(groupId);
      }
      //  店铺咨询方式
      if (form.chatMode) {
        let chatMode = this.chatOperations.find(v => v.value == form.chatMode);
        this.chatModeChange(chatMode);
      }
      //  选择所属管辖权限 
      // dataGroupName
      if (form.associatedDetails.length) {
        // let associatedDetails = this.sysDataList1.find(v => v.id == form.associatedDetails[0].dataGroupId)
        // associatedDetails && this.associatedDetailsChange(associatedDetails)
        form.associatedDetails = form.associatedDetails.map(v => v.dataGroupId);
        this.associatedDetailsChange();
      }
      if ('savingsCardOpen' in form) {
        const item = this.giftCardMode.columns.find(v => v.value == form.savingsCardOpen);
        this.onGiftCardModeConfirmChange(item);
      }

      console.log(112233);
      //   console.log(this.$refs.relatedCategory);
      console.log(this.cateLsitOption);
      setTimeout(() => {
        this.setCategoryName();
      }, 1000);

    },
    setCategoryName() {
      let cateLsitOptionData = [];

      this.cateLsitOption.forEach((item) => {
        if (this.form.relatedCategory[0][0] == item.id) {
          cateLsitOptionData.push(item);
          item.children.forEach((item2) => {
            if (this.form.relatedCategory[0][1] == item2.id) {
              cateLsitOptionData.push(item2);
              item2.children.forEach((item3) => {
                if (this.form.relatedCategory[0][2] == item3.id) {
                  cateLsitOptionData.push(item3);
                }
              });
            }
          });
        }
      });
      console.log("cateLsitOptionData");
      console.log(cateLsitOptionData);
      this.relatedCategory = cateLsitOptionData.map(v => v.categoryName).toString();
      this.form.relatedCategory = cateLsitOptionData.map(v => v.id);
      let list = JSON.parse(this.form.relatedCategoryString).map(v => v[2]);
      this.setCategoryCheck(list);
    },
    setCategoryCheck(list) {
      console.log(34455);
      // console.log(JSON.parse(this.form.relatedCategoryString));
      console.log(list);
      // 1
      this.cateLsitOption.forEach(item => {
        if (item.children && item.children.length) {
          // 2
          item.children.forEach(item1 => {
            if (item1.children && item1.children.length) {
              // 3
              item1.children.forEach(item2 => {
                item2.check = list.includes(item2.id);
              });
              // 第三级 有选中
              if (item1.children.filter(v => v.check).length) {
                item1.check = true;
                item1.checkAll = item1.children.filter(v => v.check) == item1.children.length;
              }
              else {
                // 第三级 没有选中
                item1.check = false;
                item1.checkAll = false;
              }
            }
          });
          if (item.children.filter(v => v.check).length) {
            item.check = true;
            item.checkAll = item.children.filter(v => v.check) == item.children.length;
          }
          else {
            item.check = false;
            item.checkAll = false;
          }
        }
      });
      // console.log(this.cateLsitOption);
      console.log(191919999);
      console.log(this.cateLsitOption);
    },
    onIntegralRulePickerConfirm(item) {
      const store = this.onlineStore;
      const { form } = this;
      form.integralRule = item.ruleValue;
      store.integralRuleName = item.ruleName;
      store.showRulePicker = false;
    },
    async getOnlineStorePointConfig() {
      let data = await this.http({
        method: 'GET',
        url: 'order/branch/branch/getTenantOnlineStorePointConfig',
      })
      if (!data.data) return;
      data = await this.http({
        method: 'GET',
        url: 'order/branch/branch/listOnlineOperate'
      })
      this.onlineStore = {
        ...data.data,
        showRulePicker: false,
        integralRuleName: '',
      }
    },
    getformatQuerySelectList() {
      http({url:"/order/shop/format/querySelectList",method:"post"}).then((res) => {
        if (res.code == 200) {
          res.data.forEach(element => {
            this.yetaiList.push({
              value: element.id,
              label: element.formatName
            })
          });
        }
      })
    },
    shopFormatChange(e){
      this.shopFormatName = e.label;
      this.form.shopFormatId = e.value;
      this.showshopFormat = false;
    },
  },
  components: { text }
}
</script>

<style lang="less" scoped>
.agreement_index {
  padding: 24px;
}
/deep/.van-collapse-item__title {
  font-size: 28px;
  font-weight: 500;
  // color: #3b3a38;
}
.form-crad {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  padding: 0;
  margin-bottom: 24px;
}
.img_up {
  margin-bottom: 30px;
}
.title {
  margin-top: 20px;
  // background: #fff;
  padding: 40px 0 4px 24px;
  font-size: 28px;
  font-weight: 500;
  color: #3b3a38;
  line-height: 40px;
}
/deep/.van-collapse-item__content {
  padding: 0;
}
.title-span {
  font-size: 24px;
  color: #46c18a;
  margin-left: 8px;
}
.slider-text {
  // width: 48px;
  // height: 32px;
  font-size: 24px;
  // font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b4b4b4;
  // line-height: 32px;
  text-align: center;
  padding: 36px 0;
  background: #fff;
}
/deep/.notborder::after {
  display: none !important;
}
.textarea-box {
  background: #fff;
  padding: 16px;
}
.textarea-input {
  resize: none;
  width: calc(100% - 48px);
  height: 240px;
  background: #f6f6f6;
  border-radius: 8px;
  padding: 24px;
  font-size: 24px;
  border: none;
  font-weight: 400;
  color: #3b3a38;
  line-height: 36px;
}
.img_up_div {
  position: relative;
  display: inline-block;
  width: 200px;
  height: 200px;
  margin: 5px;
  .close {
    color: red;
    font-weight: bold;
    position: absolute;
    right: 8px;
    font-size: 24px;
  }
}
.div-up {
  border: 3px dotted #ccc;
  width: 2rem;
  height: 2rem;
  position: relative;
  .div-up-1 {
    position: absolute;
    top: 30%;
    left: 30%;
  }
}
.img-text {
  flex: 1;
  font-size: 24px;
  color: #f08e3c;
  // widows: 200px;
  // background:pink;
  div {
    // position: relative;
    position: absolute;
    top: 50px;
    left: -242px;
    width: 468px;
    text-align: left;
    white-space: initial;
  }
}
.one-img {
  float: right;
  // flex: 1
}
.all-img-box {
  background: #fff;
  padding: 16px;
  .text {
    font-size: 24px;
    color: #f08e3c;
    margin-bottom: 16px;
  }
}
.all-img {
}

.dialog {
  /deep/.van-dialog__content {
    margin: 36px 0;
  }
  .dialog-row {
    display: flex;
    line-height: 44px;
    margin-left: 50px;
    margin-bottom: 12px;
    .label {
      color: #8c94a0;
    }
    .copy-icon {
      font-size: 22px;
      font-weight: 400;
      color: #f08e3c;
      background: #fef6f0;
      padding: 1px 12px;
      border-radius: 18px;
      margin-left: 16px;
    }
  }
  .text-success {
    color: #46c18a;
    width: 80%;
    margin: 24px auto;
    text-align: center;
  }
}
.proup-title {
  // width: 192px;
  // height: 40px;
  font-size: 32px;
  // font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 40px;
  // position: relative;
  text-align: center;
  padding-top: 30px;
}
.checkbox-box {
  padding-top: 24px;
  // max-height: 1062px;
  height:calc(100vh - 428px);
  
  overflow: auto;

  .checkbox-row {
    // width: 100%;
    padding: 10px 38px;
    // align-items: center;
    // justify-content: center;
    margin: 24px 0;
  }
}

/deep/.van-cell--required::before {
  display: none;
}
.van-cell--required {
  /deep/.van-cell__title.van-field__label::after {
    color: #ee0a24;
    font-size: 0.37rem;
    content: '*';
  }
}
.nowrap-input {
  /deep/.van-field__body {
    .van-field__control {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.footer-card {
  margin-bottom: 100px;
}
.footer-btn {
  position: fixed;
  bottom: 16px;
  left: 16px;
  width: calc(100% - 32px);
}
.cascader-btn {
  margin-bottom: 26px;
}
.cascader-box {
  // max-height: 70vh;
  // height: 55vh;
  margin-bottom: 0;
  // padding: 20px 0;
  // background:pink;
  .cascader-title {
    text-align: center;
    line-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 48px;
    font-weight: 500;
    color: #26282a;
    padding: 16px;
    font-size: 32px;
    .img-icon {
    }
    .close-btn {
      color: #4088ee;
    }
  }
  .cascader-body {
    margin-bottom: 16px;
  }
  .col-item.col-item-bg {
    // background: #fff;
    /deep/.van-cell {
      // padding-left: 12px;
      // background: #fff;
    }
  }
  .col-item.col-item-notbg {
    /deep/.van-checkbox-group {
      // height: 50vh;
      background: #fff !important;
      .van-cell {
        padding-left: 12px;
        background: #fff !important;
      }
    }
  }
  .col-item {
    // height: 1062px;
    height:calc(100vh - 428px);
    // background: #f4f7fc;
    overflow: auto;
    /deep/.van-checkbox-group {
      // height: calc(100vh - 128px);
      background: #f4f7fc;
    }

    .item {
    }
    .van-cell__title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-left: 12px;
    }
    .atvcheck {
      background: #fff !important;
      // color: red;
      font-weight: 500;
      // margin-left: 0;
      .check-color {
        color: #3b3a38 !important;
      }
    }
    .atvcheck::before {
      width: 8px;
      height: 32px;
      content: ' ';
      background: #4088ee;
      top: 5px;
      margin-top: 6px;
      margin-left: -12px;
      margin-right: 0;
    }
    .atvcheck1 {
      background: #fff !important;
      // color: red;
      font-weight: 500;
      .check-color {
        color: #3b3a38 !important;
      }
    }
    .check-color {
      color: #4088ee !important;
      // color: red;
    }
    /deep/.van-cell {
      padding-left: 12px;
      background: #f4f7fc;
    }
    /deep/.van-cell::after {
      display: none !important;
    }
    /deep/.van-cell-group::after {
      display: none !important;
    }
  }
  .img-icon {
    height: 48px;
  }
}
.aaaaaaaaa {
  display: inline-block;
  width: 40px;
  height: 100px;
  background: pink;
}

/deep/.van-cell {
  padding: 24px 38px;
}
/deep/.van-cell--required {
  .van-field__label {
    color: #3b3a38;
  }
}
/deep/.van-field__label {
  color: #b4b4b4;
  width: 210px !important;
}
/deep/.van-field__control {
  color: #3b3a38;
  font-weight: 400;
}
/deep/.van-field__control.van-field__control--right {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.tips-warn {
  font-size: 24px;
  color: #F08E3C;
  padding: 10px 34px 0 34px;
}
</style>

